import React from "react"
import { Layout } from "./Layout";
import {useSiren} from "./SirenContext";
import { ContactCreate } from "./subpages/ContactCreate";
import { ContactList } from "./subpages/ContactList";
import {ContactPhoneOptInList} from "./subpages/ContactPhoneOptInList";

export function Contacts() {

    const {subMenuCurrent} = useSiren()

    return (
        <Layout menuCurrent={"contacts"} >
            {subMenuCurrent === "create" && <ContactCreate/>}
            {subMenuCurrent === "active" && <ContactList key="active"/>}
            {subMenuCurrent === "archived" && <ContactList key="archived" archived/>}
            {subMenuCurrent === "opt-ins" && <ContactPhoneOptInList/>}
        </Layout>
    )


}